import { Suspense, lazy } from "react";
import { Navigate, useRoutes, useLocation } from "react-router-dom";
// layouts
import MainLayout from "../layouts/main";
import DashboardLayout from "../layouts/dashboard";
import LogoOnlyLayout from "../layouts/LogoOnlyLayout";
// guards
import GuestGuard from "../guards/GuestGuard";
// loadibng components
import LoadingScreen from "./../components/LoadingScreen";
import AuthGuard from "../guards/AuthGuard";
//customer routes
import { customerRoutes } from "./customer";
import { supplierRoutes } from "./supplier";
import { financerRoutes } from "./financer";
import CheckBankOffers from "../pages/Loan/CheckBankOffers";
import PreCibilQualification from "../components/_loan/PreCibilQualification";
import PreCibilScoreQualification from "../pages/Loan/PreCibilScoreQualification";
import LoanLayout from "../layouts/Loan";
import PendingQueries from "../components/_loan/dashboard/PendingQueries";
import LoanReview from "../components/_loan/dashboard/LoanReview";
// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();
  return (
    <Suspense
      fallback={<LoadingScreen isDashboard={pathname.includes("/dashboard")} />}
    >
      <Component {...props} />
      {/* <LoadingScreen isDashboard={pathname.includes("/dashboard")} /> */}
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    {
      path: "auth",
      element: <MainLayout />,
      children: [
        {
          path: "login",
          element: (
            <GuestGuard>
              <Login />
            </GuestGuard>
          ),
        },
        {
          path: "select-user-type",
          element: (
            <GuestGuard>
              <SelectUserType />
            </GuestGuard>
          ),
        },
        {
          path: "register",
          element: (
            <GuestGuard>
              <Register />
            </GuestGuard>
          ),
        },
        {
          path: "financier-signup",
          element: (
            <GuestGuard>
              <FinancierRegister />
            </GuestGuard>
          ),
        },
        {
          path: "forgot-password",
          element: (
            <GuestGuard>
              <ForgotPassword />
            </GuestGuard>
          ),
        },
        {
          path: "reset-password",
          element: (
            <GuestGuard>
              <ResetPassword />
            </GuestGuard>
          ),
        },
        {
          path: "verify-otp",
          element: (
            <GuestGuard>
              <VerifyOtp />
            </GuestGuard>
          ),
        },
        //   { path: 'login-unprotected', element: <Login /> },
        //   { path: 'register-unprotected', element: <Register /> },
        //   { path: 'reset-password', element: <ResetPassword /> },
        //   { path: 'verify', element: <VerifyCode /> },
      ],
    },
    // Steps Routes
    {
      path: "supplier",
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        { path: "information", element: <SupplierInformation /> },
        { path: "uinformation", element: <SupplierUpdateInfo /> },
        { path: "kyc", element: <KnowYourCustomer /> },
        { path: "banking", element: <BankingInformation /> },
        { path: "verification", element: <SupplierVerification /> },
        { path: "documentation", element: <SupplierDocumentation /> },
        { path: "signature", element: <SupplierSignature /> },
        {
          path: "quotations/view/:id",
          element: (
            <AuthGuard>
              <SupplierQuotationView />
            </AuthGuard>
          ),
        },
      ],
    },
    // Loan Routes
    {
      path: "loan",
      element: (
        <AuthGuard>
          <LoanLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: "pendingqueries/:offerId",
          element: (
            <AuthGuard>
              <PendingQueries />
            </AuthGuard>
          ),
        },
        {
          path: "loanreview",
          element: (
            <AuthGuard>
              <LoanReview />
            </AuthGuard>
          ),
        },
      ],
    },
    // Dashboard Routes
    {
      path: "dashboard",
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [{ path: "", element: <AppDashboard /> }],
    },
    {
      path: "user",
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        // { path: "", element: <AppDashboard /> },
        {
          path: "profile",
          element: (
            <AuthGuard>
              <Profile />
            </AuthGuard>
          ),
        },
        {
          path: "profile/edit",
          element: (
            <AuthGuard>
              <EditProfile />
            </AuthGuard>
          ),
        },
        {
          path: "change-password",
          element: (
            <AuthGuard>
              <ChangePassword />
            </AuthGuard>
          ),
        },
        {
          path: "edit-business",
          element: (
            <AuthGuard>
              <EditBusiness />
            </AuthGuard>
          ),
        },
        {
          path: "list-loans",
          element: (
            <AuthGuard>
              <CustomerLoanTable />
            </AuthGuard>
          ),
        },
        {
          path: "view-finacial-document",
          element: (
            <AuthGuard>
              <ViewFinancialStatement />
            </AuthGuard>
          ),
        },
        {
          path: "view-bank-document",
          element: (
            <AuthGuard>
              <ViewBankStatement />
            </AuthGuard>
          ),
        },
        {
          path: "view-cibil-document",
          element: (
            <AuthGuard>
              <ViewCibilStatement />
            </AuthGuard>
          ),
        },
        {
          path: "wishlist",
          element: (
            <AuthGuard>
              <Wishlist />
            </AuthGuard>
          ),
        },
        {
          path: "loan-scorecard/:id",
          element: (
            <AuthGuard>
              <LoanScorecardPage />
            </AuthGuard>
          ),
        },
        ...customerRoutes,
      ],
    },
    {
      path: "supplier",
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { path: "", element: <SupplierDashboard /> },
        // { path: "profile", element: <Profile /> },
        {
          path: "onboarding",
          element: <SupplierOnboarding />,
          children: [
            // { element: <Navigate to="/supplier/onboarding/basic-info" replace /> },
            { path: "basic-info", element: <SupplierBasicInfo /> },
            { path: "kyc-info", element: <SupplierKycInfo /> },
            { path: "banking-info", element: <SupplierBankingInfo /> },
            {
              path: "verification-info",
              element: <SupplierVerificationInfo />,
            },
            { path: "document-info", element: <SupplierDocumentInfo /> },
            { path: "signature-info", element: <SupplierSignatureInfo /> },
          ],
        },
        // { path: "profile/edit", element: <EditProfile /> },
        // { path: "change-password", element: <ChangePassword /> },
        { path: "products", element: <ListProducts /> },
        { path: "inventories", element: <ListInventories /> },
        { path: "products/add", element: <AddProduct /> },
        // { path: "products/:id/edit", element: <EditProduct /> },
        { path: "products/:id/detail", element: <SupplierProductDetail /> },
        {
          path: "list-loans",
          element: (
            <AuthGuard>
              <SupplierLoanTable />
            </AuthGuard>
          ),
        },
        {
          path: "view-finacial-document",
          element: <ViewFinancialStatement />,
        },
        {
          path: "view-bank-document",
          element: (
            <AuthGuard>
              <ViewBankStatement />
            </AuthGuard>
          ),
        },
        {
          path: "view-cibil-document",
          element: (
            <AuthGuard>
              <ViewCibilStatement />
            </AuthGuard>
          ),
        },
        {
          path: "products/:pId/variants/:vId",
          element: <SupplierVariantDetail />,
        },
        {
          path: "balancesheet",
          element: <BalanceSheet />,
        },
        { path: "balancesheet/add", element: <AddBalanceSheet /> },
        { path: "balancesheet/:id/edit", element: <EditBalanceSheet /> },
        { path: "balancesheet/:id/detail", element: <EditBalanceSheet /> },
        {
          path: "incomestatement",
          element: <IncomeStatement />,
        },
        {
          path: "view-finacial-document",
          element: (
            <AuthGuard>
              <ViewFinancialStatement />
            </AuthGuard>
          ),
        },
        { path: "incomestatement/add", element: <AddIncomeStatement /> },
        { path: "incomestatement/:id/edit", element: <EditIncomeStatement /> },
        ...supplierRoutes,
      ],
    },
    {
      path: "financer",
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        // { path: "", element: <SupplierDashboard /> },
        ...financerRoutes,
      ],
    },
    // Dashboard Routes
    {
      path: "loan-applications",
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { path: ":id", element: <LoanDetailPage /> },
        { path: ":id/others", element: <OtherInfoPage /> },
      ],
    },
    // Main Routes
    // Checkout Routes
    {
      path: "checkout",
      element: (
        <AuthGuard>
          <CheckoutPage />
        </AuthGuard>
      ),
    },

    // Loan process routes

    {
      path: "/loanprocess",
      element: (
        <AuthGuard>
          <LoanProcessLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: "/loanprocess",
          element: (
            <AuthGuard>
              <LoanInstructionPage />
            </AuthGuard>
          ),
        },
        {
          path: "pre-qualification",
          element: (
            <AuthGuard>
              <PreQualificationPage />
            </AuthGuard>
          ),
        },
        // {
        //   path: "pre-qualification-document",
        //   element: (
        //     <AuthGuard>
        //       <PreQualificationDocumentPage />
        //     </AuthGuard>
        //   ),
        // },
        {
          path: "pre-qualification-financial",
          element: (
            <AuthGuard>
              <PreQualificationFinancialPage />
            </AuthGuard>
          ),
        },
        {
          path: "pre-cibil-score-application",
          element: (
            <AuthGuard>
              <PreCibilScoreQualification />
            </AuthGuard>
          ),
        },
        {
          path: "pre-qualification-bank-statement",
          element: (
            <AuthGuard>
              <LoanBankStatementPage />
            </AuthGuard>
          ),
        },
        {
          path: "additional-documents",
          element: (
            <AuthGuard>
              <AdditionalDocumentsPage />
            </AuthGuard>
          ),
        },
        {
          path: "loan-application-confirmation",
          element: (
            <AuthGuard>
              <LoanConfirmationPage />
            </AuthGuard>
          ),
        },
      ],
    },
    { path: "/payment-success", element: <PaymentSuccess /> },

    {
      path: "/",
      element: <MainLayout />,
      children: [
        { path: "/", element: <HomePage /> },
        { path: "about-us", element: <About /> },
        { path: "faqs", element: <Faqs /> },
        { path: "/step-completed", element: <StepsCompletedPage /> },
        { path: "/email-verification", element: <EmailVerification /> },
        { path: "contact-us", element: <Contact /> },
        { path: "compare", element: <Compare /> },
        {
          path: "cart",
          element: (
            <AuthGuard>
              <Cart />
            </AuthGuard>
          ),
        },
        // { path: "/storefront/:slug", element: <ProductsListing /> }
        // { path: "/:slug", element: <StoreFront /> }
        {
          path: ":cat",
          element: <StoreFront />,
          children: [
            // { element: <Navigate to="/user/supplier-onboarding/basic-info" replace /> },
            { path: ":subcat", element: <StoreFront /> },
          ],
        },
        // {
        //   path: "/storefront",
        //   element: <StoreFront />,
        //   children: [
        //     // { element: <Navigate to="/user/supplier-onboarding/basic-info" replace /> },
        //     { path: ":slug", element: <StoreFront /> },
        //   ],
        // },
        {
          path: "product-detail/:product_slug",
          element: <ProductDetail />,
        },
        {
          path: "contact-with-sales/:product_slug",
          element: <ContactWithSales />,
        },
        //quote
        {
          path: "requested-quotes",
          element: (
            <AuthGuard>
              <RequestedQuotes />
            </AuthGuard>
          ),
        },
        {
          path: "view-requested-quote/:id",
          element: (
            <AuthGuard>
              <ViewRequestedQuote />
            </AuthGuard>
          ),
        },

        {
          path: "cibil-score",
          element: (
            <AuthGuard>
              <CibilScore />
            </AuthGuard>
          ),
        },

        {
          path: "check-banks-offer",
          element: (
            <AuthGuard>
              <CheckBankOffers />
            </AuthGuard>
          ),
        },
        // {
        //   path: "list-loans/view-finacial-document",
        //   element: <ViewFinancialStatement />,
        // },
        // { path: "faqs", element: <Faqs /> },
        // {
        //   path: "components",
        //   children: [
        //     { element: <ComponentsOverview /> },
        //     // FOUNDATIONS
        //     { path: "color", element: <Color /> },
        //   ],
        // },
      ],
    },
    // // Categories / products Routes
    // {
    //   path: "/:slug",
    //   element: <MainLayout />,
    //   children: [
    //     { path: "/", element: <StoreFront /> }
    //   ],
    // },
    // { path: "*", element: <Navigate to="/404" replace /> },
    {
      path: "*",
      element: <LogoOnlyLayout />,
      children: [
        { path: "404", element: <NotFound /> },
        { path: "*", element: <Navigate to="/404" replace /> },
      ],
    },
  ]);
}

// Main
const HomePage = Loadable(lazy(() => import("../pages/Home")));
const About = Loadable(lazy(() => import("../pages/About")));
const Contact = Loadable(lazy(() => import("../pages/Contact")));
const Faqs = Loadable(lazy(() => import("../pages/faq/Faqs")));
// const ComingSoon = Loadable(lazy(() => import('../pages/ComingSoon')));
// const Maintenance = Loadable(lazy(() => import('../pages/Maintenance')));
// const Pricing = Loadable(lazy(() => import('../pages/Pricing')));
// const Payment = Loadable(lazy(() => import('../pages/Payment')));
// const Page500 = Loadable(lazy(() => import('../pages/Page500')));
const NotFound = Loadable(lazy(() => import("../pages/Page404")));

// AUTHENTICATION
const Login = Loadable(lazy(() => import("../pages/auth/Login")));
const SelectUserType = Loadable(lazy(() => import("../pages/auth/UserType")));
const Register = Loadable(lazy(() => import("../pages/auth/Register")));
const FinancierRegister = Loadable(
  lazy(() => import("../pages/auth/FinancierRegister"))
);
const VerifyOtp = Loadable(lazy(() => import("../pages/auth/VerifyOtp")));
const Compare = Loadable(lazy(() => import("../pages/compare/Compare")));
const ForgotPassword = Loadable(
  lazy(() => import("../pages/auth/ForgotPassword"))
);
const ResetPassword = Loadable(
  lazy(() => import("../pages/auth/ResetPassword"))
);
// const ResetPassword = Loadable(lazy(() => import('../pages/auth/ResetPassword')));
// const VerifyCode = Loadable(lazy(() => import('../pages/auth/VerifyCode')));
const CheckoutPage = Loadable(lazy(() => import("../pages/cart/CheckoutPage")));

const SupplierInformation = Loadable(
  lazy(() => import("../pages/suppliers/SupplierInformation"))
);
const SupplierUpdateInfo = Loadable(
  lazy(() => import("../pages/suppliers/SupplierUpdateInfo"))
);
const KnowYourCustomer = Loadable(
  lazy(() => import("../pages/suppliers/KnowYourCustomer"))
);
const BankingInformation = Loadable(
  lazy(() => import("../pages/suppliers/BankingInformation"))
);
const SupplierVerification = Loadable(
  lazy(() => import("../pages/suppliers/Verification"))
);
const SupplierDocumentation = Loadable(
  lazy(() => import("../pages/suppliers/Documentation"))
);
const SupplierSignature = Loadable(
  lazy(() => import("../pages/suppliers/Signature"))
);
const StepsCompletedPage = Loadable(
  lazy(() => import("../components/StepsCompleted"))
);
const EmailVerification = Loadable(
  lazy(() => import("../components/EmailVerification"))
);

const SupplierQuotationView = Loadable(
  lazy(() => import("./../pages/Quotes/SupplierQuoteViewPage"))
);

// Dashboard
const SupplierDashboard = Loadable(
  lazy(() => import("../pages/suppliers/Dashboard/SupplierDashboard"))
);
const AppDashboard = Loadable(
  lazy(() => import("../pages/dashboard/Dashboard"))
);
//user routes
const Profile = Loadable(lazy(() => import("../pages/dashboard/Profile")));
const EditProfile = Loadable(
  lazy(() => import("../pages/dashboard/EditProfile"))
);

const ChangePassword = Loadable(
  lazy(() => import("../pages/account/ChangePassword"))
);
const EditBusiness = Loadable(
  lazy(() => import("../pages/account/EditBusiness"))
);

//wishlist
const Wishlist = Loadable(lazy(() => import("../pages/wishlist/Wishlist")));

//cart page
const Cart = Loadable(lazy(() => import("../pages/cart/Cart")));

// Order Details
const OrderDetails = Loadable(
  lazy(() => import("../pages/Orders/OrderDetails"))
);
//balancesheet
const BalanceSheet = Loadable(
  lazy(() => import("../pages/balancesheet/ListBalanceSheets"))
);
const AddBalanceSheet = Loadable(
  lazy(() => import("../pages/balancesheet/AddBalanceSheet"))
);
const EditBalanceSheet = Loadable(
  lazy(() => import("../pages/balancesheet/EditBalanceSheet"))
);

//income statements
const IncomeStatement = Loadable(
  lazy(() => import("../pages/incomestatement/ListIncomeStatement"))
);
const AddIncomeStatement = Loadable(
  lazy(() => import("../pages/incomestatement/AddIncomeStatement"))
);
const EditIncomeStatement = Loadable(
  lazy(() => import("../pages/incomestatement/EditIncomeStatement"))
);

//product
const ListProducts = Loadable(
  lazy(() => import("../pages/product/ListProducts"))
);
const AddProduct = Loadable(lazy(() => import("../pages/product/AddProduct")));

const EditProduct = Loadable(
  lazy(() => import("../pages/product/EditProduct"))
);
const SupplierProductDetail = Loadable(
  lazy(() => import("../pages/product/SupplierProductDetail"))
);
const SupplierVariantDetail = Loadable(
  lazy(() => import("../pages/product/SupplierVariantDetail"))
);
//inventory
const ListInventories = Loadable(
  lazy(() => import("../pages/product/ListInventories"))
);

//on-boarding
const SupplierOnboarding = Loadable(
  lazy(() => import("../pages/on-boarding/supplier/SupplierOnboarding"))
);
const SupplierBasicInfo = Loadable(
  lazy(() => import("../pages/on-boarding/supplier/SupplierBasicInfo"))
);
const SupplierKycInfo = Loadable(
  lazy(() => import("../pages/on-boarding/supplier/SupplierKycInfo"))
);
const SupplierBankingInfo = Loadable(
  lazy(() => import("../pages/on-boarding/supplier/SupplierBankingInfo"))
);
const SupplierVerificationInfo = Loadable(
  lazy(() => import("../pages/on-boarding/supplier/SupplierVerificationInfo"))
);
const SupplierDocumentInfo = Loadable(
  lazy(() => import("../pages/on-boarding/supplier/SupplierDocumentInfo"))
);
const SupplierSignatureInfo = Loadable(
  lazy(() => import("../pages/on-boarding/supplier/SupplierSignatureInfo"))
);

//customer / products page
const StoreFront = Loadable(lazy(() => import("../pages/shop/StoreFront")));
const ProductDetail = Loadable(
  lazy(() => import("../pages/product/ProductDetail"))
);
//customer quote request
const RequestedQuotes = Loadable(
  lazy(() => import("./../pages/customer/Quotes/RequestedQuotes"))
);
const ViewRequestedQuote = Loadable(
  lazy(() => import("./../pages/customer/Quotes/ViewRequestedQuote"))
);
const LoanInstructionPage = Loadable(
  lazy(() => import("./../pages/Loan/LoanInstructionPage"))
);
const PreQualificationPage = Loadable(
  lazy(() => import("./../pages/Loan/PreQualificationPage"))
);
const PreQualificationDocumentPage = Loadable(
  lazy(() => import("./../pages/Loan/PreQualificationDocumentPage"))
);
const AdditionalDocumentsPage = Loadable(
  lazy(() => import("./../pages/Loan/AdditionalDocumentsPage"))
);
const PreQualificationFinancialPage = Loadable(
  lazy(() => import("./../pages/Loan/PreQualificationFinancialPage"))
);
const LoanBankStatementPage = Loadable(
  lazy(() => import("./../pages/Loan/LoanBankStatementPage"))
);
const LoanConfirmationPage = Loadable(
  lazy(() => import("./../pages/Loan/LoanConfirmationPage"))
);

const CibilScore = Loadable(lazy(() => import("../pages/Loan/CibilScore")));
const LoanScorecardPage = Loadable(
  lazy(() => import("../pages/Loan/LoanScorecardPage"))
);

const LoanTable = Loadable(
  lazy(() => import("../components/_loan/Table/LoanTable"))
);

const CustomerLoanTable = Loadable(
  lazy(() => import("../components/_loan/Table/CustomerLoanTable"))
);
const SupplierLoanTable = Loadable(
  lazy(() => import("../components/_loan/Table/SupplierLoanTable"))
);
const LoanDetailPage = Loadable(
  lazy(() => import("../pages/Loan/LoanDetailPage"))
);
const OtherInfoPage = Loadable(
  lazy(() => import("../pages/Loan/OtherInfoPage"))
);

const ViewFinancialStatement = Loadable(
  lazy(() => import("../components/_loan/ViewTab/ViewFinancialStatement"))
);
const ViewBankStatement = Loadable(
  lazy(() => import("../components/_loan/ViewTab/ViewBankStatement"))
);

const ViewCibilStatement = Loadable(
  lazy(() => import("../components/_loan/ViewTab/ViewCibilStatement"))
);

const PaymentSuccess = Loadable(
  lazy(() => import("../components/payments/PaymentSuccess"))
);

// Loan process Layout
const LoanProcessLayout = Loadable(
  lazy(() => import("../layouts/loanProcess/index"))
);

// Inquiry
const ContactWithSales = Loadable(
  lazy(() => import("../pages/inquiry/ContactWithSales"))
);
